import { defineStore } from 'pinia'
import { User } from '../pages/preferences/types'
import { getUser } from '../data/pages/user'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      user: null as User | null,
      error: null as string | null,
    }
  },

  actions: {
    async getUserInfo() {
      const data = await getUser()
      this.user = data?.data ?? null
      this.error = data?.errorMessage ?? null
    },
    async clearUserState() {
      this.user = null
    },
  },
})
